var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import { getApiClient } from "../../services/AxiosClients";
const baseUrl = "/aviso/myMessageTemplate";
export default class MessageTemplateService {
    static getAll() {
        return FetchService.getSingleResponse(baseUrl + "/getAll");
    }
    static getPersonalizationMenus() {
        return FetchService.getSingleResponse(baseUrl + "/getPersonalizationMenus");
    }
    // TODO: get template variables from backend
    static getPersonalizationMenusForPipelineCreateEmailNode() {
        return new Promise((resolve, reject) => {
            resolve({
                menus: [
                    { value: "advisorFullName", text: "Advisor Full Name" },
                    { value: "advisorTitle", text: "Advisor Title" },
                    { value: "coachFullName", text: "Coach Full Name" },
                    { value: "coachTitle", text: "Coach Title" },
                    { value: "assignedToFullName", text: "Assignee Full Name" },
                    { value: "studentCumulativeGPA", text: "Student Cumulative GPA" },
                    { value: "studentDegreeName", text: "Student Degree Name" },
                    { value: "studentFirstName", text: "Student First Name" },
                    { value: "studentFullName", text: "Student Full Name" },
                    { value: "studentId", text: "Student Id" },
                    {
                        value: "studentInstitutionalEmailAddress",
                        text: "Student Institutional Email Address",
                    },
                    { value: "studentLastName", text: "Student Last Name" },
                    { value: "studentNickname", text: "Student Nickname" },
                    {
                        value: "studentPersonalEmailAddress",
                        text: "Student Personal Email Address",
                    },
                    { value: "studentProgramName", text: "Student Program Name" },
                ],
            });
        });
    }
    static getPersonalizationMenusForPipelineCreateSMSNode() {
        return new Promise((resolve, reject) => {
            resolve({
                menus: [
                    { value: "assignedToFullName", text: "Assignee Full Name" },
                    { value: "studentId", text: "Student Id" },
                    { value: "studentFullName", text: "Student Full Name" },
                    { value: "studentFirstName", text: "Student First Name" },
                    { value: "studentLastName", text: "Student Last Name" },
                    { value: "studentNickname", text: "Student Nickname" },
                    {
                        value: "studentPersonalEmailAddress",
                        text: "Student Personal Email Address",
                    },
                    {
                        value: "studentInstitutionalEmailAddress",
                        text: "Student Institutional Email Address",
                    },
                ],
            });
        });
    }
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/messageTemplates/search/findByNameLike", {
                params: { search },
            });
            return response.data._embedded.messageTemplates;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/messageTemplates/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.messageTemplates;
        });
    }
}
